import { render, staticRenderFns } from "./untactTestPage.vue?vue&type=template&id=291cb07c&scoped=true&"
import script from "./untactTestPage.vue?vue&type=script&lang=js&"
export * from "./untactTestPage.vue?vue&type=script&lang=js&"
import style0 from "./untactTestPage.vue?vue&type=style&index=0&id=291cb07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cb07c",
  null
  
)

export default component.exports